import { useQuery } from "@tanstack/react-query";
import { URLS } from "../../../infra/URLS";
import getCaneca from "../queries/getCaneca";

export default function useGetCaneca() {
  const resultQuery = useQuery([`${URLS.CANECA}`],
    () => getCaneca());

  return resultQuery;
}
